<template>
  <div class="header-box">
    <div class="header-left"
         v-if="hasUserInfo">
      <div class="logo clearfix">
        <div class="fl">
          <img v-if="!isPartner"
               src="../assets/logo_ld.png"
               alt="">
          <img v-else-if="$store.state.user.loginInfo.partner_logo_url"
               :src="$store.state.user.loginInfo.partner_logo_url">
        </div>
        <div class="fl"
             v-if="!isPartner">
          <div class="logoTitle">魔镜增长雷达</div>
          <div class="logoText">MKTINDEX.COM</div>
        </div>
        <div v-else
             class="fl">
          <div style="height: 100%; line-height: 50px;font-size: 16px; font-weight: 700">{{$store.state.user.loginInfo.partner_title}}</div>
        </div>
        <div class="fl"
             v-if="!isPartner">
          <el-popover placement="bottom-start"
                      trigger="hover">
            <div>
              <img style="width: 200px"
                   src="../assets/kf.jpeg"
                   alt="">
            </div>
            <div style="text-align:center; display: inline-block; width: 190px">{{$t("topHead.QRcode_contact")}}</div>
            <i class="iconfont icon-kefu kf"
               slot="reference"><span class="text">{{$t("topHead.contact_us")}}</span></i>
          </el-popover>
        </div>
        <div class="fl"
             v-if="!isPartner">
          <el-popover placement="bottom-start"
                      trigger="hover">
            <div>
              <img src="../assets/product.png"
                   alt=""
                   style="width: 200px;height: 200px">
            </div>
            <div style="text-align:center; width: 200px">{{$t("topHead.product_question")}}</div>
            <div style="text-align:center; width: 200px">{{$t("topHead.scan_code")}}</div>
            <i class="iconfont icon-kefu2 kf"
               slot="reference"><span class="text">{{$t("topHead.apply_for")}}</span></i>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="header-right">
      <template v-if="showCatPicker">
        <TopSearch />

      </template>
      <div class="myAtention"
           v-show="false">
        <i class="iconfont icon-heart-fill"
           style="color:#FF7875 ;margin-right:12px"></i>
        <span class="headText">{{$t('topHead.my_attention')}}</span>
      </div>
      <div v-if="language == 'zh' && !isOversea"
           style="font-size: 14px; color: #606266;">数据展示：中文</div>
      <el-dropdown v-if="language == 'zh' && isOversea"
                   placement="bottom-start"
                   @command="changeLanguageMode">
        <span>
          <span v-show="languageMode == 'system'">数据展示：中文</span>
          <span v-show="languageMode == 'source'">数据展示：源语言</span>
          <span v-show="languageMode == 'both'">数据展示：源语言 + 中文</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="system">数据展示：中文</el-dropdown-item>
          <el-dropdown-item command="source">数据展示：源语言</el-dropdown-item>
          <el-dropdown-item command="both">数据展示：源语言 + 中文</el-dropdown-item>
        </el-dropdown-menu>
        <el-dropdown-menu />
      </el-dropdown>
      <el-dropdown v-if="language == 'en'"
                   placement="bottom-start"
                   @command="changeLanguageMode">
        <span>
          <span v-show="languageMode == 'system'">Data Language: English</span>
          <span v-show="languageMode == 'source'">Data Language: Original Language</span>
          <span v-show="languageMode == 'both'">Data Language: Original Language + English</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="system">Data Language: English</el-dropdown-item>
          <el-dropdown-item command="source">Data Language: Original Language</el-dropdown-item>
          <el-dropdown-item command="both">Data Language: Original Language + English</el-dropdown-item>
        </el-dropdown-menu>
        <el-dropdown-menu />
      </el-dropdown>

      <el-dropdown style="margin-left:20px"
                   placement="bottom-start"
                   @command="changeLanguge">
        <span>{{languageText}}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh">系统语言：中文</el-dropdown-item>
          <el-dropdown-item command="en">System language: English</el-dropdown-item>
        </el-dropdown-menu>
        <el-dropdown-menu />
      </el-dropdown>
      <userinfo @userLogin="userLoginValue"
                @on-changeLanguage="changeLanguage"> </userinfo>
    </div>

  </div>
</template>

<script>
import TopSearch from './TopSearch.vue'
import { userinfo } from 'common'
import { getUrlParams } from '@/utils'
import { getObjFromUrl } from '@/utils'
import { getWordTs, getJdWordTs } from '@/api/public'
import Cookies from 'js-cookie'
export default {
  components: {
    userinfo,
    TopSearch,
  },
  data() {
    return {
      loginInfo: {},
      ts: '',
      showCatPicker: false,
      language: localStorage.getItem('language'),
      // 类目相关
      plat: 'all',
      isOversea:
        window.location.hash.includes('amazon') ||
        window.location.hash.includes('publicDetail')
          ? true
          : false,
    }
  },
  methods: {
    userLoginValue(val) {
      this.loginInfo = val
      this.$store.dispatch('user/changeLoginInfo', val)
      this.$store.dispatch(
        'user/changeShowDownloadBtn',
        this.loginInfo.download
      )
      let { cid, ts } = this.rand_cat(val.cat_list)
      let { ts: jd_ts } = this.rand_cat(val.jd_cat_list, 'jd')
      this.rand_cat(val.douyin_cat_list, 'douyin')
      this.rand_cat(val.chance_cat_list, 'chance_all')
      this.rand_cat(val.chance_jd_cat_list, 'chance_jd')
      this.oversea_cat(val.ebay_cat_list, 'ebay')
      this.oversea_cat(val.gamazon_cat_list, 'gamazon')
      this.oversea_cat(val.amazon_de_cat_list, 'amazon_de')
      this.oversea_cat(val.amazon_uk_cat_list, 'amazon_uk')
      this.oversea_cat(val.amazon_jp_cat_list, 'amazon_jp')
      this.shopee_cat(val.shopee_id_cat_list, 'shopee_id')
      this.shopee_cat(val.shopee_th_cat_list, 'shopee_th')
      this.shopee_cat(val.shopee_vn_cat_list, 'shopee_vn')
      this.shopee_cat(val.shopee_my_cat_list, 'shopee_my')
      this.shopee_cat(val.shopee_ph_cat_list, 'shopee_ph')
      this.shopee_cat(val.shopee_sg_cat_list, 'shopee_sg')
      this.lazada_cat(val.lazada_id_cat_list, 'lazada_id')
      this.lazada_cat(val.lazada_th_cat_list, 'lazada_th')
      this.lazada_cat(val.lazada_vn_cat_list, 'lazada_vn')
      this.lazada_cat(val.lazada_my_cat_list, 'lazada_my')
      this.lazada_cat(val.lazada_ph_cat_list, 'lazada_ph')
      this.lazada_cat(val.lazada_sg_cat_list, 'lazada_sg')

      if (getUrlParams('cid')) {
        this.cid = getUrlParams('cid')
      } else {
        this.cid = cid
      }
      if (getUrlParams('ts')) {
        this.ts = getUrlParams('ts')
      } else {
        this.ts = this.plat == 'jd' ? jd_ts : ts
      }
      this.$store.dispatch('user/changeName', val.username)
      this.$store.dispatch('user/changeCatId', this.cid)
      this.$store.dispatch('user/changeTs', this.ts)
    },
    rand_cat(catlist, plat = 'all') {
      let level = []
      if (catlist == 'all') {
        if (plat == 'all') {
          this.$store.dispatch('user/changeLoginCatList', 'all')
        } else if (plat == 'jd') {
          this.$store.dispatch('user/changeJdLoginCatList', 'all')
        } else if (plat == 'chance_all') {
          this.$store.dispatch('user/changeChanceLoginCatList', 'all')
        } else if (plat == 'chance_jd') {
          this.$store.dispatch('user/changeChanceJdLoginCatList', 'all')
        } else if (plat == 'douyin') {
          this.$store.dispatch('user/changeDouyinLoginCatList', 'all')
        }
        let ts = getUrlParams('ts') ? getUrlParams('ts') : this.ts
        let cid = getUrlParams('cid') ? getUrlParams('cid') : '16'
        return { cid: cid, ts: ts }
      } else if (plat == 'jd') {
        if (catlist.cat_id == 'all') {
          this.$store.dispatch('user/changeJdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeJdLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeJdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeJdLoginCatLevel', level)
        }

        let cid = ''
        let ts = ''
        if (level.length > 0 && !cid) {
          cid = level[0]['cat_id']
        }
        if (level.length > 0 && !ts) {
          ts = level[0]['ts']
        } else {
          ts = this.ts
        }
        return { cid: cid, ts: ts }
      } else if (plat == 'chance_all') {
        if (catlist.cat_id == 'all') {
          this.$store.dispatch('user/changeChanceLoginCatList', 'notAll')
          this.$store.dispatch('user/changeChanceLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeChanceLoginCatList', 'notAll')
          this.$store.dispatch('user/changeChanceLoginCatLevel', level)
        }
      } else if (plat == 'chance_jd') {
        if (catlist.cat_id == 'all') {
          this.$store.dispatch('user/changeChanceJdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeChanceJdLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeChanceJdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeChanceJdLoginCatLevel', level)
        }
      } else if (plat == 'douyin') {
        if (catlist.cat_id == 'all') {
          this.$store.dispatch('user/changeDouyinLoginCatList', 'notAll')
          this.$store.dispatch('user/changeDouyinLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeDouyinLoginCatList', 'notAll')
          this.$store.dispatch('user/changeDouyinLoginCatLevel', level)
        }
      } else {
        if (catlist.cat_id == 'all') {
          this.$store.dispatch('user/changeLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLoginCatLevel', level)
        }
        let cid = ''
        let ts = ''
        if (level.length > 0 && !cid) {
          cid = level[0]['cat_id']
        }
        if (level.length > 0 && !ts) {
          ts = level[0]['ts']
        } else {
          ts = this.ts
        }
        return { cid: cid, ts: ts }
      }
    },
    oversea_cat(catlist, plat) {
      let cid, ts
      let level = []
      if (catlist == 'all') {
        if (plat == 'ebay') {
          this.$store.dispatch('user/changeEbayLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : '1853126'
        } else if (plat == 'gamazon') {
          this.$store.dispatch('user/changeAmazonLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : '3760911'
        } else if (plat == 'amazon_de') {
          this.$store.dispatch('user/changeAmazonDeLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : '1111111100000002'
        } else if (plat == 'amazon_uk') {
          this.$store.dispatch('user/changeAmazonUkLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : '1111111100000002'
        } else if (plat == 'amazon_jp') {
          this.$store.dispatch('user/changeAmazonJpLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : '1111111100000013'
        }
        ts = getUrlParams('ts') ? getUrlParams('ts') : this.ts
        return { cid, ts }
      }
      if (plat == 'ebay') {
        this.$store.dispatch('user/changeEbayLoginCatList', 'notAll')
        this.$store.dispatch('user/changeEbayLoginCatLevel', catlist)
      } else if (plat == 'gamazon') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeAmazonLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeAmazonLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonLoginCatLevel', level)
        }
      } else if (plat == 'amazon_de') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeAmazonDeLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonDELoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeAmazonDeLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonDeLoginCatLevel', level)
        }
      } else if (plat == 'amazon_uk') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeAmazonUkLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonUkLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeAmazonUkLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonUkLoginCatLevel', level)
        }
      } else if (plat == 'amazon_jp') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeAmazonJpLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonJpLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeAmazonJpLoginCatList', 'notAll')
          this.$store.dispatch('user/changeAmazonJpLoginCatLevel', level)
        }
      }
      if (catlist.length > 0 && !cid) {
        cid = catlist[0]['cat_id']
      }
      if (catlist.length > 0 && !ts) {
        ts = catlist[0]['ts']
      } else {
        ts = this.ts
      }
    },
    shopee_cat(catlist, plat) {
      let cid, ts
      let level = []
      if (catlist == 'all') {
        if (plat == 'shopee_id') {
          this.$store.dispatch('user/changeShopeeIdLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'shopee_th') {
          this.$store.dispatch('user/changeShopeeThLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'shopee_vn') {
          this.$store.dispatch('user/changeShopeeVnLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'shopee_my') {
          this.$store.dispatch('user/changeShopeeMyLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'shopee_ph') {
          this.$store.dispatch('user/changeShopeePhLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'shopee_sg') {
          this.$store.dispatch('user/changeShopeeSgLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        }
        ts = getUrlParams('ts') ? getUrlParams('ts') : this.ts
        return { cid, ts }
      }
      if (plat == 'shopee_id') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeShopeeIdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeIdLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeShopeeIdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeIdLoginCatLevel', catlist)
        }
      } else if (plat == 'shopee_th') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeShopeeThLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeThLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeShopeeThLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeThLoginCatLevel', catlist)
        }
      } else if (plat == 'shopee_vn') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeShopeeVnLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeVnLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeShopeeVnLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeVnLoginCatLevel', catlist)
        }
      } else if (plat == 'shopee_my') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeShopeeMyLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeMyLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeShopeeMyLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeMyLoginCatLevel', catlist)
        }
      } else if (plat == 'shopee_ph') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeShopeePhLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeePhLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeShopeePhLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeePhLoginCatLevel', catlist)
        }
      } else if (plat == 'shopee_sg') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeShopeeSgLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeSgLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeShopeeSgLoginCatList', 'notAll')
          this.$store.dispatch('user/changeShopeeSgLoginCatLevel', catlist)
        }
      }
      if (catlist.length > 0 && !cid) {
        cid = catlist[0]['cat_id']
      }
      if (catlist.length > 0 && !ts) {
        ts = catlist[0]['ts']
      }
    },
    lazada_cat(catlist, plat) {
      let cid, ts
      let level = []
      if (!catlist) return
      if (catlist == 'all') {
        if (plat == 'lazada_id') {
          this.$store.dispatch('user/changeLazadaIdLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'lazada_th') {
          this.$store.dispatch('user/changeLazadaThLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'lazada_vn') {
          this.$store.dispatch('user/changeLazadaVnLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'lazada_my') {
          this.$store.dispatch('user/changeLazadaMyLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'lazada_ph') {
          this.$store.dispatch('user/changeLazadaPhLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        } else if (plat == 'lazada_sg') {
          this.$store.dispatch('user/changeLazadaSgLoginCatList', 'all')
          cid = getUrlParams('cid') ? getUrlParams('cid') : ''
        }
        ts = getUrlParams('ts') ? getUrlParams('ts') : this.ts
        return { cid, ts }
      }
      if (plat == 'lazada_id') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeLazadaIdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaIdLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLazadaIdLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaIdLoginCatLevel', catlist)
        }
      } else if (plat == 'lazada_th') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeLazadaThLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaThLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLazadaThLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaThLoginCatLevel', catlist)
        }
      } else if (plat == 'lazada_vn') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeLazadaVnLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaVnLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLazadaVnLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaVnLoginCatLevel', catlist)
        }
      } else if (plat == 'lazada_my') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeLazadaMyLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaMyLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLazadaMyLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaMyLoginCatLevel', catlist)
        }
      } else if (plat == 'lazada_ph') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeLazadaPhLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaPhLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLazadaPhLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaPhLoginCatLevel', catlist)
        }
      } else if (plat == 'lazada_sg') {
        if (catlist.cat_id == 'all' || catlist.length == 0) {
          this.$store.dispatch('user/changeLazadaSgLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaSgLoginCatLevel', catlist)
        } else {
          level = [
            ...catlist.level1,
            ...catlist.level2,
            ...catlist.level3,
            ...catlist.level4,
          ]
          this.$store.dispatch('user/changeLazadaSgLoginCatList', 'notAll')
          this.$store.dispatch('user/changeLazadaSgLoginCatLevel', catlist)
        }
      }
      if (catlist.length > 0 && !cid) {
        cid = catlist[0]['cat_id']
      }
      if (catlist.length > 0 && !ts) {
        ts = catlist[0]['ts']
      }
    },
    handleRemove(key) {},
    changeLoginState(val) {},
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    //切换语言
    changeLanguge(lan) {
      // this.$i18n.locale = lan
      localStorage.setItem('language', lan)
      this.language = lan
      Cookies.set('cmiLanguage', lan, {
        path: '/',
        expires: 365,
        domain: 'mktindex.com',
      })
      location.reload()
    },
    changeLanguage(val) {
      if (this.language !== val) {
        this.language = val
        localStorage.setItem('language', val)
        location.reload()
      }
    },
    changeLanguageMode(command) {
      this.languageMode = command
      localStorage.setItem('languageMode', command)
    },
    /* -------- 类目相关方法  -----------*/
    mulltipSelectRemoveTag() {},
    clearSelect() {},
  },
  computed: {
    hasUserInfo() {
      return Object.keys(this.$store.state.user.loginInfo).length > 0
    },
    isPartner() {
      return this.$store.state.user.loginInfo.is_partner
    },
    languageText() {
      if (this.language == 'en') {
        return 'System language: English'
      } else {
        return '系统语言：中文'
      }
    },
    languageMode: {
      get() {
        return this.$store.state.user.languageMode
      },
      set(val) {
        this.$store.dispatch('user/changeLanguageMode', val)
        localStorage.setItem('languageMode', val)
      },
    },
  },
  watch: {
    '$store.state.user.selectedKeyWards': {
      handler(newVal, oldVal) {
        this.keyWards = newVal.replace(new RegExp('&amp;', 'g'), '&')
      },
    },
    $route: {
      handler(newVal, oldVal) {
        // 海外不需要TopSearch newVal.path == '/publicDetail'
        if (newVal.path == '/detail') {
          this.showCatPicker = true
        } else if (newVal.path == '/concept') {
          if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
          }
          this.timeout = setTimeout(() => {
            this.showCatPicker = true
          }, 2000)
        } else {
          if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = null
          }
          this.showCatPicker = false
        }

        // 详情页修改tabs页逻辑
        // let param_val = getObjFromUrl(window.location.href)
        let param_val = this.$route.query
        if (param_val.plat) {
          this.plat = param_val.plat
        }
        if (param_val.cid) {
          this.cat = param_val.cid
          this.defaultCheckedKeys = [this.cat]
        }
        if (newVal.name.includes('amazon') || newVal.name == 'publicDetail') {
          this.isOversea = true
        } else {
          this.isOversea = false
          if (this.language == 'zh') {
            this.changeLanguageMode('system')
          }
        }
      },
    },
  },
  created() {
    const cookieLanguage = Cookies.get('cmiLanguage')
    const currentLanguage = localStorage.getItem('language')
    if (cookieLanguage && cookieLanguage !== currentLanguage) {
      localStorage.setItem('language', cookieLanguage)
      this.language = cookieLanguage
      location.reload()
    }
    setTimeout(() => {
      // 海外不需要TopSearch this.$route.path == '/publicDetail'
      if (this.$route.path == '/detail') {
        this.showCatPicker = true
      }
      if (this.$route.path == '/concept') {
        this.timeout = setTimeout(() => {
          this.showCatPicker = true
        }, 2000)
      }
    }, 200)
  },
}
</script>

<style scoped lang='less'>
.header-box {
  align-items: normal !important;
}
.header-left {
  color: #ff7d00;
  min-width: 500px;
  .lb {
    display: inline-block;
  }
  .logo {
    img {
      height: 35px;
      margin-top: 10px;
      margin-right: 12px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .logoTitle {
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ff7d00;
      margin-top: 8px;
      line-height: 30px;
    }
    .logoText {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #ff7d00;
      transform: scale(0.7);
      text-align: center;
      line-height: 10px;
    }
  }
  .kf {
    margin-left: 30px;
    cursor: pointer;
    line-height: 56px;
    font-size: 24px;
  }
  .text {
    display: inline-block;
    font-size: 14px;
    vertical-align: top;
    margin-left: 4px;
  }
}
.header-right {
  .select {
    position: relative;
  }
  /deep/ .el-icon-search {
    font-size: 18px;
  }
}
.catSearch {
  /deep/ input {
    width: 180px;
    height: 32px;
    background-color: #ff7d00;
    color: #fff;
    border-radius: 4px 0px 0px 4px;
  }
}
</style>
<style lang='less'>
.outer-container .outheader .header-box .header-right .user {
  margin-left: 20px !important;
}
</style>
